import { render, staticRenderFns } from "./SelectComponentType.vue?vue&type=template&id=2e8d3b32&scoped=true"
import script from "./SelectComponentType.vue?vue&type=script&lang=js"
export * from "./SelectComponentType.vue?vue&type=script&lang=js"
import style0 from "./SelectComponentType.vue?vue&type=style&index=0&id=2e8d3b32&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8d3b32",
  null
  
)

export default component.exports